import { Map } from 'immutable'
import { handleActions, combineActions } from 'redux-actions'
import { combineReducers } from 'redux-immutable'

import * as actions from './actions'

const loaded = handleActions({
  [combineActions(actions.setLoaded, actions.timedOut)]: () => true,
}, false)

export default combineReducers({
  loaded,
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/experiment/reducer.js